import React from 'react';
import { Route } from 'react-router-dom';

import Categories from 'features/products/pages/categories/Categories';
import ProductGroups from 'features/products/pages/product-groups/ProductGroups';
import Products from 'features/products/pages/Products';

export const productsRoutes = (
  <Route path='products'>
    <Route index element={<Products />} />
    <Route path='categories' element={<Categories />} />
    <Route path='groups' element={<ProductGroups />} />
  </Route>
);

export const productsTitles = [
  { path: '/products/categories', title: 'Категории товаров' },
  { path: '/products/groups', title: 'Группы товаров' },
  { path: '/products', title: 'Товары' },
];
